module.exports = "/static/assets/bc487cde787d1a887f7d5494e707ef46.svg";